export default __webpack_public_path__ + "55dfd489d16f6ae50a35b9a087d877f4.svg";